import { render, staticRenderFns } from "./scope-edit.vue?vue&type=template&id=2c03e65a&"
import script from "./js/scope-edit.js?vue&type=script&lang=js&"
export * from "./js/scope-edit.js?vue&type=script&lang=js&"
import style0 from "./scope-edit.vue?vue&type=style&index=0&id=2c03e65a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports